import { render, staticRenderFns } from "./SimpleBookingOverview.vue?vue&type=template&id=881f8b84&scoped=true"
import script from "./SimpleBookingOverview.vue?vue&type=script&lang=js"
export * from "./SimpleBookingOverview.vue?vue&type=script&lang=js"
import style0 from "./SimpleBookingOverview.vue?vue&type=style&index=0&id=881f8b84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "881f8b84",
  null
  
)

export default component.exports